import {Main} from '../components/main/main.tsx';
import {PageTitle} from '../components/page/page_title.tsx';
import {Page} from '../components/page/page.tsx';
import {PageContent} from '../components/page/page_content.tsx';
import {FlexRow} from '../components/utility/flex_row.tsx';
import {Alignment} from '../enums/alignment.ts';
import {Button} from '../components/button/button.tsx';
import {Header} from '../components/header/header.tsx';
import {transString} from '../support/lang/translations.ts';
import {FlexColumn} from '../components/utility/flex_column.tsx';
import {Spacer} from '../components/utility/spacer.tsx';
import {useAppSelector} from '../store/store.ts';
import {isAuthenticatedSelector} from '../store/slices/exchange_token_slice.ts';
import {isRouteErrorResponse, useRouteError} from 'react-router-dom';

interface OwnProps {
    code?: number;
}

export function ErrorPage({code}: OwnProps) {
    const routeError = useRouteError();
    const isAuthenticated = useAppSelector(isAuthenticatedSelector);
    let effectiveCode = code;

    if (effectiveCode == null) {
        if (isRouteErrorResponse(routeError)) {
            effectiveCode = routeError.status;
        } else {
            effectiveCode = 500;
        }
    }

    return (
        <Main>
            <Header />
            <FlexColumn alignment={Alignment.Center} grow={1}>
                <Page>
                    <PageTitle>
                        <FlexColumn alignment={Alignment.Center}>
                            <FlexRow alignment={Alignment.Center}>
                                <h1>{effectiveCode ?? ''}</h1>
                            </FlexRow>
                            <FlexRow alignment={Alignment.Center}>
                                <h2>{transString(`errors.${effectiveCode}.title`)}</h2>
                            </FlexRow>
                        </FlexColumn>
                    </PageTitle>
                    {isAuthenticated && (
                        <PageContent>
                            <FlexColumn alignment={Alignment.Center}>
                                <FlexRow alignment={Alignment.Center}>
                                    <h3>{transString(`errors.${effectiveCode}.description`)}</h3>
                                </FlexRow>
                                <FlexRow>
                                    <Spacer style={{height: '3rem'}} />
                                </FlexRow>
                                <FlexRow alignment={Alignment.Center}>
                                    <Button to={'/'}>
                                        <i className="fa-light fa-house" />
                                        Home
                                    </Button>
                                </FlexRow>
                            </FlexColumn>
                        </PageContent>
                    )}
                </Page>
            </FlexColumn>
        </Main>
    );
}
